import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { array } from "yup";
import useContentLaboratorio from "../hooks/parameter/useContentLaboratorio";

import { fetchListaConfiguracion } from "../services/parameter.service";
import SaberMas from "./Buttons/SaberMas";

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .iframe-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100% !important;
    height: 100vh !important;

    iframe {
      width: 60% !important;
      height: 100% !important;
      margin: 0 auto;

      @media (max-width: 1000px) {
        width: 70% !important;
      }

      @media (max-width: 800px) {
        width: 100% !important;
      }
    }
  }
`;

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 400px;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;
    // width: 80%;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

const CustomButton = styled.a`
  background-color: #04AAAA;
  color: #fff;
  font-size: ${(props) => 16 * props.fontsizemultiplier};
  border: 1px solid;
  padding: 5rem 10rem;
  margin-bottom: 2rem;
  border-radius: 100px;
  font-weight: 700;
  font-size: 20px;
  letter-spacing: 1px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  transition: all 0.3s;

  @media (max-width: 1150px) {
    margin-top: 5rem;
  }

  &:hover,
  &:focus {
    transform: scale(1.05);
    text-decoration: none;
    filter: brightness(1.1);
    color: #fff;
    letter-spacing: 2px;
  }
`;

export const PageLaboratorio = () => {
  window.scroll(0, 0);

  const [laboratorioUrl, setLaboratorioUrl] = useState(null);
  const [showIframe, setShowIframe] = useState(false);

  const handleClick = () => (
    setShowIframe(!showIframe)
  )

  const getUrl = async () => {
    try {
      const response = await fetchListaConfiguracion({
        key: "URL_LABORATORIOS",
      });

      setLaboratorioUrl(response.data.list[0]?.value);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUrl();
  }, []);

  const { contentLaboratorio } = useContentLaboratorio();

  const bodyHTML =
    contentLaboratorio.length > 0 && contentLaboratorio[0].texto_completo;

  return (
    <>
      <div style={{
        display: "flex",
        justifyContent: "center",
        padding: "3rem 0",
      }}>
        <CustomButton onClick={() => handleClick()} >
          Descargar Resultados
        </CustomButton>
      </div>
      {showIframe && (
        <Container id="contBodyHTML">
          <div className="iframe-container">
            <iframe
              src={laboratorioUrl}
              title="Doctor Famedic"
              frameborder="0"
            ></iframe>
          </div>
        </Container>
      )}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
      }}>
        <DivContainer id="contBodyHTMLImage">
          <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
        </DivContainer>
      </div>
    </>
  );
};
